export default {
  cashRegister: {
    // Page tip
    tipLabel: 'Tip',
    pageTip: 'Cash registers automatically appear in the list after QR-code activation. Device codes are generated by the business system.',
    // Filters
    deviceCode: 'Device Code',
    deviceName: 'Device Name',
    store: 'Store',
    enableStatus: 'Enable Status',
    onlineStatus: 'Online Status',
    activatedTime: 'Activation Time',
    enabled: 'Enabled',
    disabled: 'Disabled',
    online: 'Online',
    offline: 'Offline',
    // Summary tabs
    allTab: 'All Cash Registers',
    // Table
    softwareVersion: 'Software Version',
    edit: 'Edit',
    unbind: 'Unbind',
    unbinding: 'Unbinding',
    // Empty states
    // Edit drawer
    editCashRegister: 'Edit Cash Register',
    deviceInfo: 'Device Information',
    basicSettings: 'Basic Settings',
    nameRequired: 'Please enter a device name.',
    nameLengthLimit: 'The device name cannot exceed 20 characters.',
    nameHint: '1-20 characters',
    namePlaceholder: 'e.g. Cashier 1',
    planned: 'Planned',
    salesWarehouse: 'Sales Warehouse',
    exchangeWarehouse: 'Exchange Warehouse',
    recycleWarehouse: 'Recycle Warehouse',
    enabledSwitch: 'Enabled',
    enabledSwitchHelp: 'When off, this cash register is disabled and cannot be used.',
    coinService: 'Coin Add/Collect Service',
    coinServiceHelp: 'Shift-based coin add/collect workflows will be configurable in the future.',
    secondScreenCart: 'Second Screen Cart',
    secondScreenCartHelp: 'Whether to show the cart on the customer-facing screen will be configurable in the future.',
    confirmStopTitle: 'Confirm Disable Cash Register',
    confirmEnableTitle: 'Confirm Enable Cash Register',
    confirmStopContent: 'Disable "{store} {name}"? After disabling, this cash register cannot be used.',
    confirmEnableContent: 'Enable "{store} {name}"? After enabling, this cash register can be used again.',
    saveSuccess: 'Device information saved',
    discardChangesTitle: 'Discard Unsaved Changes',
    discardChangesConfirm: 'There are unsaved changes on this page. Once discarded, these changes cannot be restored.',
    continueEditing: 'Continue Editing',
    discardChanges: 'Discard Changes',
    // Unbind
    confirmUnbindTitle: 'Confirm Unbind Cash Register',
    normalUnbindConfirm: 'Business validation passed. Unbind this cash register? After unbinding, it will be removed from the current list and cannot be used; a new activation code is required for future use.',
    blockedTitle: 'Cannot Unbind Yet',
    blockedPrefix: 'This cash register has unfinished business:',
    forceRiskNoteAllowed: 'Only accounts with force-unbind permission can ignore all business validation and online status. This may cause unsynced or abnormal business data.',
    forceRiskNoteDenied: 'The current account does not have force-unbind permission. Please contact an administrator with the required permission.',
    forceUnbind: 'Force Unbind',
    forceUnbindTitle: 'Force Unbind Cash Register',
    forceUnbindDesc: 'Force unbinding ignores all business validation and online status. After unbinding, the cash register will be removed from the current list.',
    forceUnbindRisk: 'Orders, shifts, or device data may not be synced. Please confirm that the risks have been assessed.',
    forceInputLabel: 'Enter the following text to confirm',
    forceInputPlaceholder: 'Enter the risk confirmation text',
    forceInputHint: 'The input must match exactly, without extra spaces.',
    forceUnbindPhrase: 'I understand the risks and confirm the unbind',
    // Unbind blockers (maps to backend UnbindBlockerCodeEnum; unknown codes fall back to the backend message)
    blockerCode: {
      deviceDisabled: 'Device is disabled and cannot be unbound',
      deviceOffline: 'Device is offline',
      orderUnfinished: 'There are unfinished orders',
      shiftUnclosed: 'The current shift has not been closed',
      coinFlowInProgress: 'A coin add/collect process is in progress',
    },
    processingTitle: 'Unbinding',
    forceProcessingTitle: 'Force Unbinding',
    processingDoNotRepeat: 'Processing, please do not repeat the operation.',
    processingDesc: 'The system is removing the current binding of this cash register.',
    validatingTitle: 'Validating Device Status',
    validatingHint: 'Validating online status and unfinished business. Please wait.',
    failureTitle: 'Unbind Failed',
    forceFailureTitle: 'Force Unbind Failed',
    failureDesc: 'The unbind was not completed. The cash register remains in the current list. Please check the network or system status and try again.',
    retryUnbind: 'Retry Unbind',
    unbindSuccess: 'Unbind successful, the cash register has been removed from the current list',
    forceUnbindSuccess: 'Force unbind successful, the cash register has been removed from the current list',
    // Errors and loading
    listLoadFailed: 'Failed to load the cash register list. Please try again later',
    editFailed: 'Failed to save. Please try again later',
    checkFailed: 'Failed to validate the unbind. Please try again later',
    generalSettings: 'General/Other',
    businessDaySettings: 'Business Day Settings',
    businessDayCutoverTime: 'Business Day Cutover Time',
    businessDayHint: 'Defaults to 00:00 and applies uniformly to all stores under the brand. Changes take effect from the next business day; the current and past business days remain unchanged.',
    businessDayEffectiveDate: 'Effective business day for the saved settings: {date}',
    businessDayLoadFailed: 'Failed to load business day settings. Please try again.',
    businessDayRetry: 'Reload',
    businessDayTimeRequired: 'Please select a cutover time on the hour',
    businessDaySaveSuccess: 'Business day settings saved',
    shiftManagement: 'Shift Management',
    addShiftTemplate: 'Add Shift',
    shiftTemplateName: 'Shift Name',
    shiftNameColumn: 'Shift',
    enableStatusColumn: 'Enable Status',
    startTime: 'Start Time',
    endTime: 'End Time',
    timeRange: 'Time Range',
    nextDay: 'Next Day ',
    applicableStores: 'Applicable Stores',
    shiftTemplateNameRequired: 'Please enter a shift name',
    startTimeRequired: 'Please select a start time',
    endTimeRequired: 'Please select an end time',
    applicableStoresRequired: 'Please select applicable stores',
    shiftTemplateSaveSuccess: 'Shift added successfully',
    editShiftTemplate: 'Edit Shift',
    shiftTemplateUpdateSuccess: 'Shift updated successfully',
    enableShift: 'Enable',
    disableShift: 'Disable',
    shiftTemplateStatusConfirm: 'Are you sure you want to {action} this shift?',
    shiftTemplateStatusSuccess: 'Shift status updated successfully',
    shiftTemplateDeleteConfirm: 'Are you sure you want to delete this shift?',
    shiftTemplateDeleteSuccess: 'Shift deleted successfully',
    allStores: 'All Stores',
    storeCountDisplay: '{count} stores',
    specifiedStores: 'Specified Stores',
    selectStores: 'Select Stores',
    selectedStoreCount: '{count} stores selected',
    noStoresSelected: 'Please select stores',
  },

};
